import debounce from 'lodash.debounce'
const MyESIMSPagesMixin = (pageName) => ({
  components: {
    Sim: () => import('~/components/sim/item.vue'),
    EmptyView: () => import('~/components/my-esims/empty-view'),
    SupportedCountriesModal: () => import('~/components/modals/supported-countries-modal'),
    LottiePreloader: () => import('~/components/lottie-preloader.vue'),
    ReferralBanner: () => import('~/components/banners/referral.vue'),
  },
  computed: {
    emptyType() {
      if (this.$auth.loggedIn) {
        if (this.showFreemium) {
          return 'freemium'
        } else if (this.showReferral) {
          return 'referral'
        } else {
          return 'empty'
        }
      }
      return this.$featureFlag.isActive('freemium') ? 'freemium' : 'login'
    },
  },
  data() {
    return {
      mySimsType: pageName,
      emptyViewWait: true,
      scrollDebounce: null,
      mySims: null,
      visibleIds: [],
      showReferral: false,
      showFreemium: false,
      showRenewals: false,
      modals: {
        supportedCountries: {
          model: false,
          countries: [],
        },
      },
    }
  },
  methods: {
    async pageData(type) {
      this.mySims = null
      try {
        const { data } = await this.$axios.get(`/v2/users/me/sims/?type=${type}`)

        if (!data?.data?.length) {
          this.mySims = null
          if (process.client) {
            this.readRemoteConfig()
          }
        } else {
          this.mySims = data.data
            .filter((sim) => sim.operator !== null)
            .map((v) => ({
              ...v,
              dataUsageLoader: false,
              dataUsage: {
                isApi: v.operator.phones && v.operator.phones.usage_type === 'api',
                planType: v.operator.plan_type,
              },
            }))

          this.emptyViewWait = false

          setTimeout(() => {
            ;(async () => {
              this.geteSIMsUsageDataAfterGetVisibleElements()
            })()
          }, 200)
        }
      } catch (error) {
        this.mySims = null

        if (process.client) {
          this.readRemoteConfig()
        }
      }
    },
    async geteSIMsUsageDataAfterGetVisibleElements() {
      const isLength = await this.getVisibleElements()
      if (isLength) {
        this.geteSIMsUsageData()
      } else {
        const isLength = await this.getVisibleElements()
        if (isLength) {
          this.geteSIMsUsageData()
        }
      }
      if (process.client) {
        this.readRemoteConfig()
      }
    },
    async geteSIMsUsageData() {
      this.visibleIds = [...new Map(this.visibleIds.map((item) => [item['id'], item])).values()].filter(
        (v) => !this.eSimHasDataLoaded(v)
      )

      this.visibleIds.forEach((v) => {
        const index = this.mySims.findIndex((x) => x.id === v.id)
        this.mySims[index].dataUsageLoader = true
      })

      try {
        const responses = await Promise.all(
          this.visibleIds.map((v) => this.$axios.get(`/v3/users/me/sims/${v.id}/usage`))
        )

        if (responses && responses.length > 0) {
          responses.forEach((v) => {
            const index = this.mySims.findIndex((x) => x.id === v.data.id)

            this.mySims[index].dataUsage.data = v.data
            this.mySims[index].dataUsageLoader = false
          })
        }

        this.visibleIds = []
      } catch (error) {}
    },
    eSimHasDataLoaded(elemOrIdx) {
      const elem = typeof elemOrIdx === 'number' ? this.mySims[elemOrIdx] : elemOrIdx

      return elem.dataUsage?.data || elem.dataUsageLoader
    },
    elementIsPartiallyInViewPort(element) {
      const rect = element.getBoundingClientRect()
      const viewPortHeight = window.innerHeight || document.documentElement.clientHeight
      const viewPortWidth = window.innerWidth || document.documentElement.clientWidth
      return (
        ((rect.top >= 0 && rect.top < viewPortHeight) || (rect.bottom >= 0 && rect.bottom < viewPortHeight)) &&
        ((rect.left >= 0 && rect.left < viewPortWidth) || (rect.right >= 0 && rect.right < viewPortWidth))
      )
    },
    async getVisibleElements() {
      const allItems = document.querySelectorAll('.sim-item-list')

      allItems.forEach((v, i) => {
        if (this.elementIsPartiallyInViewPort(v) && !this.eSimHasDataLoaded(i)) {
          this.visibleIds.push(this.mySims[i])
        }
      })

      this.visibleIds = [...new Map(this.visibleIds.map((item) => [item['id'], item])).values()].filter(
        (v) => !this.eSimHasDataLoaded(v)
      )

      return allItems.length > 0
    },
    async scrollCallback() {
      await this.getVisibleElements()
      this.geteSIMsUsageData()
    },
    cancelScroll() {
      if (this.scrollDebounce) {
        window.removeEventListener('scroll', this.scrollDebounce)
        this.scrollDebounce.cancel()
      }
    },
    readRemoteConfig() {
      try {
        const hasFreemiumFeature = this.$featureFlag.isActive('freemium')
        const isUserEligible = this.$store.state.auth.user?.is_freemium_claimable
        if (hasFreemiumFeature && isUserEligible) {
          this.showFreemium = true
        } else {
          this.showReferral = this.$store.state.auth.user?.referral?.show_banner
        }
        this.showRenewals = this.$featureFlag.isActive('renewal_feature_flag')
        this.emptyViewWait = false
      } catch (e) {
        this.showFreemium = false
        this.showReferral = false
        this.emptyViewWait = false
        return
      }
    },
    onOpenSupportedCountries(countries) {
      this.modals.supportedCountries.countries = countries
      this.modals.supportedCountries.model = true
    },
    onCloseSupportedCountries() {
      this.modals.supportedCountries.model = false
    },
    async updateEsim() {
      try {
        const { data: esims } = await this.$axios.$get('/v2/users/me/sims/?type=normal')

        if (Array.isArray(esims) && Array.isArray(this.mySims)) {
          this.mySims = this.mySims.map((sim) => {
            const newSim = esims.find((v) => v.id === sim.id)

            if (newSim && newSim.post_kyc_status) {
              sim.post_kyc_status = newSim.post_kyc_status
            }

            return sim
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  async mounted() {
    if (process.client) {
      const eventName = pageName === 'normal' ? 'myesimsPageViewEvent' : 'myesimsArchivedViewEvent'

      this.$utils.sendEvent(eventName)

      if (!this.mySims && this.$auth.loggedIn) {
        await this.pageData(this.mySimsType)
      } else {
        this.readRemoteConfig()
      }

      this.$root.$on('update-eSIM', this.updateEsim)
    }
  },
  beforeDestroy() {
    this.cancelScroll()
    this.$root.$off('update-eSIM')
  },
  created() {
    this.$store.commit('set_mobile_header_text', '')

    if (process.client) {
      this.scrollDebounce = debounce(this.scrollCallback, 200)
      window.addEventListener('scroll', this.scrollDebounce)
    }
  },
})

export default MyESIMSPagesMixin
